import { useState } from "react";
import { http } from "@/lib/api";
import { toast } from "sonner";
import { Modal } from "./AdminShared";

export default function ResetModal({ onClose, onDone }) {
  const [opts, setOpts] = useState({
    orders: true, payment_transactions: true, subscriptions: true,
    referrals: true, partner_applications: true, partner_payouts: true,
    partner_users_and_locations: false, contact_messages: false, newsletter: false,
    test_customers: false, qr_scan_counts: false,
  });
  const [confirm, setConfirm] = useState("");
  const [running, setRunning] = useState(false);
  const labels = {
    orders: "All orders",
    payment_transactions: "Payment transactions (Stripe sessions)",
    subscriptions: "Subscription records",
    referrals: "Referrals + clear user credits",
    partner_applications: "Partner applications",
    partner_payouts: "Partner payouts",
    partner_users_and_locations: "Partner users (downgrade) + their locations",
    contact_messages: "Contact form messages",
    newsletter: "Newsletter subscribers",
    test_customers: "All non-admin user accounts",
    qr_scan_counts: "Reset QR scan & purchase counts to zero",
  };
  const run = async () => {
    if (confirm !== "DELETE") { toast.error("Type DELETE to confirm."); return; }
    if (!Object.values(opts).some(Boolean)) { toast.error("Pick at least one item."); return; }
    setRunning(true);
    try {
      const { data } = await http.post("/admin/reset-test-data", { confirm, ...opts });
      const summary = Object.entries(data.summary || {}).map(([k, v]) => `${k}: ${v}`).join(", ");
      toast.success(`Cleared — ${summary || "done"}`);
      onDone();
    } catch (err) { toast.error(err?.response?.data?.detail || "Reset failed."); }
    finally { setRunning(false); }
  };
  return (
    <Modal title="Reset Test Data" onClose={onClose}>
      <div className="space-y-4 text-sm">
        <p className="font-body text-[#B5B0A7]">Pick what to wipe. <span className="text-red-400">This cannot be undone.</span> Your admin account and artwork catalog are always preserved.</p>
        <div className="space-y-2">
          {Object.entries(labels).map(([k, l]) => (
            <label key={k} className="flex items-center gap-3 p-2 border border-white/10 hover:bg-white/5 cursor-pointer" data-testid={`reset-opt-${k}`}>
              <input type="checkbox" className="accent-[#C9A055]" checked={opts[k]} onChange={e => setOpts({...opts, [k]: e.target.checked})}/>
              <span className="text-[#F4F1EA]">{l}</span>
            </label>
          ))}
        </div>
        <div>
          <div className="font-ui text-[10px] tracking-[0.22em] text-red-400 mb-1">Type DELETE to confirm</div>
          <input data-testid="reset-confirm" value={confirm} onChange={e => setConfirm(e.target.value)} className="stc-input font-mono"/>
        </div>
        <div className="flex justify-end gap-3 pt-3 border-t border-white/10">
          <button onClick={onClose} className="btn-outline">Cancel</button>
          <button data-testid="reset-run-btn" onClick={run} disabled={running} className="btn-gold bg-red-600 hover:bg-red-700 border-red-600">{running ? "Wiping…" : "Wipe Selected"}</button>
        </div>
      </div>
    </Modal>
  );
}
